import { ClickOutside } from '@alkem/react-ui-click-outside';
import classNames from 'classnames';
import { Component } from 'react';
import SplitButtonAlternativeAction from './alternative-action';
import { ButtonProps } from './types';

class SplitButtonDropdown extends Component<{
  dropup?: boolean;
  dropleft?: boolean;
  options: ButtonProps[];
  onClick: (option?: ButtonProps) => void;
}> {
  public handleClickOutside = () => {
    this.props.onClick();
  };

  public render() {
    const { dropup, dropleft, options, onClick } = this.props;
    return (
      <ClickOutside
        className={classNames(
          'dropdown-menu',
          dropup && 'drop-up',
          dropleft && 'drop-left'
        )}
        onClickOutside={this.handleClickOutside}
      >
        {options.map((option) => (
          <SplitButtonAlternativeAction
            key={option.id || option.text || ''}
            option={option}
            onClick={onClick}
          />
        ))}
      </ClickOutside>
    );
  }
}

export default SplitButtonDropdown;
